import SkeletonHeader from "./SkeletonHeader";
import SkeletonBox from "./SkeletonBox";

const LEGEND_WIDTHS = [60, 50, 40];

const MapSkeleton = ({ className = "" }: { className?: string }) => {
  return (
    <div className={`w-100 ${className}`}>
      <div className="apple-card gestalt-group group border-0 shadow-sm rounded-5 p-4 h-100 skeleton-card">
        <div className="mb-4">
          <SkeletonHeader titleWidth="35%" subtitleWidth="25%" />
        </div>

        <div className="position-relative mb-4">
          <SkeletonBox className="skeleton-medium" width="100%" height={320} style={{ borderRadius: 20 }} />

          <div className="position-absolute top-0 start-0 m-4 d-flex flex-column gap-2">
            <SkeletonBox width={40} height={40} className="skeleton-secondary" style={{ borderRadius: "50%" }} />
            <SkeletonBox width={28} height={28} className="skeleton-secondary" style={{ borderRadius: "50%" }} />
          </div>

          <div className="position-absolute top-50 start-50 translate-middle d-flex gap-2">
            <SkeletonBox width={16} height={16} className="skeleton-secondary" style={{ borderRadius: "50%" }} />
            <SkeletonBox width={18} height={18} className="skeleton-secondary" style={{ borderRadius: "50%" }} />
            <SkeletonBox width={14} height={14} className="skeleton-secondary" style={{ borderRadius: "50%" }} />
          </div>

          <div className="position-absolute bottom-0 end-0 m-4 d-flex flex-column gap-2 align-items-end">
            <SkeletonBox width={55} height={14} className="skeleton-overlay" style={{ borderRadius: 999 }} />
            <SkeletonBox width={35} height={14} className="skeleton-overlay" style={{ borderRadius: 999 }} />
          </div>
        </div>

        <div className="d-flex flex-wrap gap-3 align-items-center">
          {LEGEND_WIDTHS.map((w, i) => (
            <div key={i} className="d-flex align-items-center gap-2">
              <SkeletonBox width={12} height={12} className="skeleton-light" style={{ borderRadius: "50%" }} />
              <SkeletonBox width={w} height={12} className="skeleton-light" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MapSkeleton;
